import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ml-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = { class: "ml-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { class: "ml-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { class: "ml-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { class: "ml-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "ml-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = { class: "ml-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = { class: "ml-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = { class: "ml-2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = { class: "ml-2" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = { key: 0 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = ["value"]

import {useI18n} from "vue-i18n";
import {Ref, toRef} from "vue";
import DateToStringHelper from "@/utilities/helpers/DateToStringHelper";
import {formatBytes} from "@/utilities/helpers/ByteStringHelper";
import NullOrUndefinedHelper from "@/utilities/helpers/NullOrUndefinedHelper";
import ProjectFile from "@/models/entities/ProjectFile";


export default /*#__PURE__*/_defineComponent({
  __name: 'FileDetailPopup',
  props: {
  data: Object
},
  setup(__props) {

const {t} = useI18n();
const props = __props
const popupData = toRef(props, 'data') as Ref<ProjectFile>;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createTextVNode(_toDisplayString(_unref(t)("dashboard.tabs.file.popups.details.fileName")) + ": ", 1),
    _createElementVNode("span", _hoisted_1, _toDisplayString(popupData.value.name), 1),
    _hoisted_2,
    _createTextVNode(" " + _toDisplayString(_unref(t)("dashboard.tabs.file.popups.details.description")) + ": ", 1),
    _createElementVNode("span", _hoisted_3, _toDisplayString(popupData.value.description), 1),
    _hoisted_4,
    _createTextVNode(" " + _toDisplayString(_unref(t)("dashboard.tabs.file.popups.details.fileSize")) + ": ", 1),
    _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(formatBytes)(popupData.value.sizeInBytes)), 1),
    _hoisted_6,
    _createTextVNode(" " + _toDisplayString(_unref(t)("dashboard.tabs.file.popups.details.fileType")) + ": ", 1),
    _createElementVNode("span", _hoisted_7, _toDisplayString(popupData.value.type) + " (" + _toDisplayString(popupData.value.extension) + ")", 1),
    _hoisted_8,
    _createTextVNode(" " + _toDisplayString(_unref(t)("dashboard.tabs.file.popups.details.desc")) + ": ", 1),
    _createElementVNode("span", _hoisted_9, _toDisplayString(popupData.value.description ?? ""), 1),
    _hoisted_10,
    _createTextVNode(" " + _toDisplayString(_unref(t)("dashboard.tabs.file.popups.details.creator")) + ": ", 1),
    _createElementVNode("span", _hoisted_11, _toDisplayString(popupData.value.owner.displayName), 1),
    _hoisted_12,
    _createTextVNode(" " + _toDisplayString(_unref(t)("dashboard.tabs.file.popups.details.changed")) + ": ", 1),
    _createElementVNode("span", _hoisted_13, _toDisplayString(popupData.value.modifiedAt ? _unref(DateToStringHelper)(new Date(popupData.value.modifiedAt)) : ""), 1),
    _hoisted_14,
    _createTextVNode(" " + _toDisplayString(_unref(t)("dashboard.tabs.file.popups.details.deleteToDate")) + ": ", 1),
    _createElementVNode("span", _hoisted_15, _toDisplayString(popupData.value.deletion.scheduledDate ? _unref(DateToStringHelper)(new Date(popupData.value.deletion.scheduledDate)) : ""), 1),
    _hoisted_16,
    _createTextVNode(" " + _toDisplayString(_unref(t)("dashboard.tabs.file.popups.details.activeTicketCount")) + ": ", 1),
    _createElementVNode("span", _hoisted_17, _toDisplayString(popupData.value.activeTicketCount), 1),
    _hoisted_18,
    _createTextVNode(" " + _toDisplayString(_unref(t)("dashboard.tabs.file.popups.details.uploadProgress")) + ": ", 1),
    _createElementVNode("span", _hoisted_19, _toDisplayString(popupData.value.uploadProgress) + "%", 1),
    _hoisted_20,
    _hoisted_21,
    (!_unref(NullOrUndefinedHelper)(popupData.value.messageToCreator))
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createTextVNode(_toDisplayString(_unref(t)("dashboard.tabs.file.grid.messageToCreator")) + ":", 1),
          _hoisted_23,
          _createElementVNode("textarea", {
            class: "w-full min-h-[80px]",
            value: popupData.value.messageToCreator,
            disabled: true
          }, null, 8, _hoisted_24)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})